import React from 'react';
import './DriverAndVehicle.css'
import DriverPhoto from "./DriverPhoto";
import {PublicApiDriverSummaryResponse, PublicApiVehicleSummaryResponse} from "../Representation";

interface DriverAndVehicleProps {
    apiOrigin: string
    trackingToken: string
    driver: PublicApiDriverSummaryResponse
    vehicle: PublicApiVehicleSummaryResponse
    circular: boolean
}

const DriverAndVehicle = (
    props: DriverAndVehicleProps
) => {

    const { driver, vehicle } = props;
    const driverFullName = driver.firstName + " " + driver.lastNameInitial;

    return (
        <div className="driver row middle-sm">
            {driver.hasPhoto &&
                <DriverPhoto
                    apiOrigin={props.apiOrigin}
                    trackingToken={props.trackingToken}
                    driver={driver}
                    circular={props.circular}
                />
            }
            <p>
                <span className={"name"}>{driverFullName}</span><br />
                {vehicle.typeDescription}<br />
                {vehicle.registration}
            </p>
        </div>
    )

}

export default DriverAndVehicle;
